import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;

const apiClient = new APIClient();

// Helper function to stringify query parameters
const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Get Right Exercise Type List with Query (for remote operations)
export const getRightExerciseTypeListQuery = params => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_RIGHT_EXERCISE_TYPES}?${stringifyParams(
			params
		)}`
	);
};

// Get Right Exercise Type List with Query
export const getRightExerciseTypeList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
		// populate: ['creation_user', 'modification_user'],
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['name:asc'],
		...params,
	};

	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_RIGHT_EXERCISE_TYPES}?${stringifyParams(
			queryParams
		)}`
	);
};

// Get Single Right Exercise Type
export const getRightExerciseType = right_exercise_type_id => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_RIGHT_EXERCISE_TYPE}${right_exercise_type_id}`
	);
};

// Add New Right Exercise Type
export const addNewRightExerciseTypeApi = right_exercise_type => {
	return apiClient.create(
		`${WATER_RIGHTS_BASE}${url.POST_RIGHT_EXERCISE_TYPE}`,
		right_exercise_type
	);
};

// Update Right Exercise Type
export const updateRightExerciseTypeApi = right_exercise_type => {
	return apiClient.put(
		`${WATER_RIGHTS_BASE}${url.PUT_RIGHT_EXERCISE_TYPE}${right_exercise_type._id}`,
		right_exercise_type
	);
};

// Delete Right Exercise Type
export const deleteRightExerciseTypeApi = right_exercise_type_id => {
	return apiClient.delete(
		`${WATER_RIGHTS_BASE}${url.DELETE_RIGHT_EXERCISE_TYPE}${right_exercise_type_id}`
	);
};

// Check if Right Exercise Type Exists
export const checkRightExerciseTypeExistsApi = name => {
	const queryParams = {
		filters: {
			name: {
				$eq: name,
			},
		},
		fields: ['_id'],
		pagination: {
			page: 1,
			pageSize: 1,
		},
	};

	return apiClient
		.get(
			`${WATER_RIGHTS_BASE}${
				url.CHECK_RIGHT_EXERCISE_TYPE_EXISTS
			}?${stringifyParams(queryParams)}`
		)
		.then(response => {
			return { exists: response && response.length > 0 };
		})
		.catch(() => {
			return { exists: false };
		});
};
